import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api'
import type { EnvironmentWixCodeSdkSiteConfig } from '../types'

const environmentWixCodeSdkSiteConfig: SiteConfigFn<EnvironmentWixCodeSdkSiteConfig> = ({ api }) => {
	const shouldLoadSiteFeature = api.features.isActive('platform')

	const shouldLoadSiteConfig = false

	return {
		shouldLoadSiteFeature,
		shouldLoadSiteConfig,
		siteConfig: null,
	}
}

const name = 'environment-wix-code-sdk'

export const config = { site: environmentWixCodeSdkSiteConfig, name }
